import styled from "@emotion/styled";
import { interactiveText } from "@silvertours/front-shared";
var BannerBackground = /*#__PURE__*/ styled("div", {
    target: "evu72rm0"
})("background:", function(param) {
    var theme = param.theme;
    return "linear-gradient(to right,  ".concat(theme.color.primaryGradient1, ", ").concat(theme.color.primary, ")");
}, ";");
var BannerPromoText = /*#__PURE__*/ styled("p", {
    target: "evu72rm1"
})(interactiveText, "  margin:auto;");
export { BannerBackground, BannerPromoText };
